import { io } from "socket.io-client";
import constants from "./constants";

const URL = constants.baseUrl || "http://localhost:1010";

export const socket = io(URL);